import { render, staticRenderFns } from "./order-tracking.component.vue?vue&type=template&id=f4a1eb48&"
import script from "./order-tracking.component.vue?vue&type=script&lang=ts&"
export * from "./order-tracking.component.vue?vue&type=script&lang=ts&"
import style0 from "./order-tracking.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "order-tracking.component.vue"
export default component.exports